<template>
  <div class="kongjian">
    <a-row style="height: 100%">
      <a-col :span="17" style="height: 100%">
        <ShowWpsFile ref="showWpsFile" :btnShow="false" :fileCode="code" :isReadOnly="'false'"/>
      </a-col>
      <a-col :span="7">
        <a-row class="op-row">
          <a-col :span="8" class="title">
            <template v-if="currAuditStatus == 6">校稿结论：</template>
            <template v-else-if="currAuditStatus == 0">处理类型：</template>
            <template v-else>审稿结论：</template>
          </a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              @change="selectChange"
              v-model="auditStatus"
            >
              <a-select-option :value="1" v-if="currAuditStatus == 0">
                收稿
              </a-select-option>
              <a-select-option :value="4" v-if="currAuditStatus == 2">
                通过并送副主编审核
              </a-select-option>
              <a-select-option :value="4" v-if="currAuditStatus == 3">
                送副主编审核
              </a-select-option>
              <a-select-option :value="9" v-if="currAuditStatus == 6">
                送副主编校对
              </a-select-option>
              <a-select-option :value="33">退改</a-select-option>
              <a-select-option :value="44">退稿</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row
          class="op-row"
          v-if="this.auditStatus == '4' || this.auditStatus == '9'"
        >
          <a-col :span="8" class="title">副主编：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              v-model="extraInfo.selEditor"
              @change="onEditorChange"
            >
              <a-select-option
                v-for="item in editorList"
                :value="item.userCode"
                :key="item.userCode"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="auditStatus != 1">
          <a-col :span="8" class="title">
            <template v-if="currAuditStatus == 6">校稿意见：</template>
            <template v-else>审稿意见：</template>
          </a-col>
          <a-col :span="14">
            <a-textarea
              id="textarea"
              v-model="auditOpinion"
              :autoSize="{ minRows: 4, maxRows: 8 }"
            ></a-textarea>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">备注：</a-col>
          <a-col :span="14">
            <a-textarea
              id="textarea"
              v-model="note"
              :autoSize="{ minRows: 4, maxRows: 8 }"
            ></a-textarea>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">中图分类号：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.cnNo" />
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">文章标识码：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.articleType" />
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">文章编号：</a-col>
          <a-col :span="14">
            <a-input v-model="extraInfo.articleNo" />
          </a-col>
        </a-row>
        <a-row class="op-row" v-if="manuscript.result != 0">
          <a-col :span="8" class="title">{{
            manuscript.result == 33 ? "退改意见：" : "退稿意见："
          }}</a-col>
          <a-col :span="14">
            <div style="height: 36px; line-height: 36px">
              {{ manuscript.auditOpinion }}
            </div>
          </a-col>
        </a-row>
        <div class="btn_div">
          <a-button id="cancel" name="btn" @click="cancel"> 关闭 </a-button>
          <a-button id="save" name="btn" @click="save"> 保存 </a-button>
          <a-button id="submit" name="btn" type="primary" @click="submit">
            提交
          </a-button>
        </div>
        <div class="btn_div">注：修改文档后使用Ctrl + S 保存文档</div>
        <div class="btn_div">
          <a-button id="preview" name="btn" @click="previewFile">
            文档预览
          </a-button>
        </div>
      </a-col>
    </a-row>
    <PreviewCreateFile
      ref="previewCreateFile"
      :fileId="code"
      @previewFileClose="
        () => {
          this.$refs.showWpsFile.openWps();
        }
      "
    />
  </div>
</template>

<script>
import qs from "qs";
import ShowWpsFile from "../../../commomon/ShowWpsFile.vue";
import PreviewCreateFile from "../../../commomon/PreviewCreateFile.vue";
export default {
  name: "manager",
  data() {
    return {
      code: "",
      currAuditStatus: 0,
      status: 2,
      editorList: [],
      extraInfo: {
        selEditor: "",
        selEditorName: "",
        cnNo: "",
        articleType: "",
        articleNo: "",
      },
      auditStatus: null,
      auditOpinion: "",
      note: "",
      previewVisible: false,
      spinning: false,
      manuscript: {},
    };
  },
  components: {
    ShowWpsFile,
    PreviewCreateFile,
  },
  created() {
    this.code = this.$route.query.code;
    this.currAuditStatus = this.$route.query.auditStatus; // 稿件当前审核状态
    this.axios
      .get("/manuscripts/queryByCode", {
        params: {
          code: this.code,
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data.code == "OK") {
          this.manuscript = res.data.data;
          this.extraInfo.cnNo = this.manuscript.cnNo;
          this.extraInfo.articleType = this.manuscript.articleType;
          this.extraInfo.articleNo = this.manuscript.articleNo;
        }
      });
    this.axios
      .get("/reviewLog/queryReviewLog", {
        params: {
          code: this.code,
          isSubmit: 0,
          auditer: sessionStorage.getItem("userCode"),
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data != "") {
          this.status = res.data.status + "";
          this.auditStatus = res.data.auditStatus;
          this.auditOpinion = res.data.auditOpinion;
          this.note = res.data.note;
          if (res.data.extraInfo) {
            this.extraInfo = JSON.parse(res.data.extraInfo);
          }
        }
      });
    this.axios
      .get("/systemUser/queryEditor", {
        params: {
          roleName: "副主编",
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        this.editorList = res.data;
        this.extraInfo.selEditor = this.editorList[0].userCode;
        this.extraInfo.selEditorName = this.editorList[0].name;
      });
  },
  mounted() {
    let _this = this;
    _this.$nextTick(() => {
      setTimeout(() => {
        // 编辑未收稿件打开后见状态改为已读
        if (_this.currAuditStatus == 0) {
          _this.axios
            .post("/mineManuscripts/updateMineManuscripts", {
              code: _this.code,
              status: 1,
            })
            .then((res) => {});
        }
      }, 500);
    });
  },
  methods: {
    cancel() {
      if (this.currAuditStatus == 0) {
        this.$router.push("/myManuscript");
      } else if (
        this.currAuditStatus == 1 ||
        this.currAuditStatus == 2 ||
        this.currAuditStatus == 3 ||
        this.currAuditStatus == 6
      ) {
        this.$router.push("/notBack");
      }
    },
    async save() {
      this.$refs.showWpsFile.saveDoc(-1);
      let delRes = await this.deleteUncommit();
      if (delRes) {
        this.axios
          .post("/reviewLog/saveReviewLog", {
            code: this.code,
            status: this.status,
            auditer: sessionStorage.getItem("userCode"),
            auditOpinion: this.auditOpinion,
            extraInfo: JSON.stringify(this.extraInfo),
            isSubmit: 0,
            auditStatus: this.auditStatus,
            note: this.note,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "操作成功");
              if (this.currAuditStatus == 0) {
                this.$router.push("/myManuscript");
              } else if (
                this.currAuditStatus == 1 ||
                this.currAuditStatus == 2 ||
                this.currAuditStatus == 3
              ) {
                this.$router.push("/notBack");
              }
            } else {
              this.utils.messageInfo(this, "error", res.data.data);
            }
          });
      }
    },
    async audit() {
      this.$refs.showWpsFile.saveDoc(-1);
      let delRes = await this.deleteUncommit();
      if (delRes) {
        this.axios
          .post("/manuscripts/audit", {
            code: this.code,
            status: this.status,
            userCode: sessionStorage.getItem("userCode"),
            auditOpinion: this.auditOpinion,
            extraInfo: JSON.stringify(this.extraInfo),
            isSubmit: 1,
            auditStatus: this.auditStatus,
            note: this.note,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              if (this.currAuditStatus == 0) {
                this.$router.push("/myManuscript");
              } else if (
                this.currAuditStatus == 1 ||
                this.currAuditStatus == 2 ||
                this.currAuditStatus == 3 ||
                this.currAuditStatus == 6
              ) {
                this.$router.push("/notBack");
              }
            } else {
              this.$notification["warning"]({
                message: "提示",
                description: res.data.data,
              });
            }
          });
      }
    },
    async deleteUncommit() {
      let res = await this.axios.post("/reviewLog/deleteReviewLog", {
        code: this.code,
        auditer: sessionStorage.getItem("userCode"),
        isSubmit: 0,
      });
      return res.data.code == "OK";
    },
    submit() {
      if (this.auditStatus == null) {
        this.$notification["warning"]({
          message: "提示",
          description: "请选择处理类型！",
        });
        return;
      } else {
        this.audit();
      }
    },
    selectChange(status) {
      if (status == 44) {
        this.auditOpinion = "感谢来稿，未被采用。";
        this.status = 4;
      } else if (status == 33) {
        this.auditOpinion = "请您修改稿件。";
        this.status = 3;
      } else {
        this.status = 2;
        this.auditOpinion = "";
      }
    },
    onEditorChange(val) {
      this.extraInfo.selEditorName = this.editorList.find(
        (item) => item.userCode == val
      ).name;
    },
    previewFile() {
      this.$refs.previewCreateFile.previewFile();
    },
  },
};
</script>
<style scoped>
.kongjian {
  height: 100%;
  background-color: #fff;
}
.kongjian .btn_div {
  text-align: center;
  margin-top: 10px;
}
.kongjian .btn_div button {
  margin: 0 5px;
}
.kongjian .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
.kongjian .op-row {
  margin-top: 10px;
}
</style>
